import {connect} from "react-redux";

import Grid from "./Grid";
import deltas from "../../redux/actions/deltas";
import signals from "../../redux/actions/signals";
import roles from "../../redux/roles";
import { selectIsReloadingPayments } from "../../redux/reducers/states/reloadingPayments";

const {
    addValueToPaymentsGridTextFilter,
    removeValueFromPaymentsGridTextFilter,
    clearPaymentsGridTextFilter,
    cyclePaymentsGridColumnSortState,
    setPaymentsGridDateFilter,
    clearPaymentsGridDateFilter,
} = deltas.actionCreators;

const {
    reloadPayments,
} = signals.actionCreators;

const mapStateToProps = (state) => ({
    rowsFromRedux: state.paymentsGrid.filteredSortedData,
    selectedRows: state.paymentsGrid.selectedRows,
    gridStateSliceName: 'paymentsGrid',
    isCec: roles.CEC === state.role,
    isLoading: selectIsReloadingPayments(state),
    backendSorted: true,
});

const mapDispatchToProps = dispatch => ({
    addValueToTextFilter: addValueToPaymentsGridTextFilter,
    removeValueFromTextFilter: removeValueFromPaymentsGridTextFilter,
    clearTextFilter: clearPaymentsGridTextFilter,
    cycleColumnSortState: cyclePaymentsGridColumnSortState,
    setDateFilter: setPaymentsGridDateFilter,
    clearDateFilter: clearPaymentsGridDateFilter,
    reloadTable: reloadPayments,
});


export default connect(mapStateToProps, mapDispatchToProps)(Grid);
